{
  "authority": "https://devtankhq-auth.osmm.devtank.co.uk",
  "client_id": "osm-portal",
  "client_secret": "5UD5Y1ClqDFaHWMdQtKLEgSLYXK4Catw",
  "apiUrl": "https://devtankhq-portal.osmm.devtank.co.uk/internal",
  "dbApi": "https://devtankhq-portal.osmm.devtank.co.uk/api",
  "dbToken": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiY3VzdG9tZXIifQ.uXFJKtfRMWiST5I2OyrumlTkBU_Uu9ZJ30CAZa3HPGA"
}

